import styled, { css } from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const SportsCarouselWrapper = styled.div`
  padding: 0.7em 0;

  ${({ hidePadding }) =>
    hidePadding &&
    css`
      padding: 0;
    `}

  ${themeMedia.desktop`
    padding: 1em 0;
    
    ${({ hidePadding }) =>
      hidePadding &&
      css`
        padding: 0;
      `}
  `}
`
